import React from "react";
import "./DeviceMock.scss";
import { Link } from "react-router-dom";
import rightArrowGreen from "../../assets/icons/rightArrowGreen.svg";

interface DeviceMockProps {
  dHeader: string;
  dDesc: string;
  dImg: string;
  dAlt: string;
  dLink: string;
}

export default function DeviceMock(props: DeviceMockProps) {
  const { dHeader, dDesc, dImg, dAlt, dLink } = props;

  return (
    <div className="deviceMock">
      <section className="deviceMock__left">
        <Link to={dLink} className="deviceMock__link-header">
          <h3 className="deviceMock__header">{dHeader}</h3>
        </Link>
        <p className="deviceMock__text">{dDesc}</p>
        <Link to={dLink} className="deviceMock__link-arrow">
          <p className="deviceMock__link-text">Learn more</p>
          <img
            src={rightArrowGreen}
            alt="Right Arrow"
            className="deviceMock__arrow"
          />
        </Link>
      </section>
      <section className="deviceMock__right">
        <img src={dImg} alt={dAlt} className="deviceMock__img" />
      </section>
    </div>
  );
}
